var zhCn = { exports: {} };
export {
  zhCn as __module
};
//# sourceMappingURL=zh-cn2.js.map
